const Table = {
  baseStyle: {
    list: {
      boxShadow:
        'rgba(22, 23, 24, 0.35) 0px 10px 38px -10px, rgba(22, 23, 24, 0.2) 0px 10px 20px -15px',
      borderRadius: '4px',
      border: 'none',
      padding: '12px 16px',
    },
    item: {
      color: 'textPrimary',
      px: 0,
      py: 0,
      lineHeight: 2.2,
      _hover: {
        bgColor: 'rgb(244, 245, 245)',
      },
    },
    divider: {
      my: '8px',
      borderBottomColor: 'rgb(238, 240, 240)',
    },
  },
}

export default Table
